<div id="playlist-select">
	<a class="button" (click)="addToNewPlaylist()"><i class="fa fa-list-ol"></i> {{ 'CREATE_NEW_PLAYLIST' | translate }} </a>
	<!-- seach filter-->
	<bb-table-local-filter></bb-table-local-filter>
	<!-- container to allow scrolling through bb-table-container content -->
	<div class="playlist-container">
		<bb-table-container>
			<!-- allow filtering -->
			<bb-table-header>
				<bb-table-header-cell property="title">{{ 'TITLE' | translate }}</bb-table-header-cell>
			</bb-table-header>
			<!-- only show title -->
			<bb-table-row *ngFor="let row of rows" [row]="row" (click)="addToExistingPlaylist($event, row)">
				<bb-table-cell property="title" class="overflow">{{ row.data.title }}</bb-table-cell>
			</bb-table-row>
		</bb-table-container>
		<div class="no-results" *ngIf="rows && !rows.length">{{ 'NO_PLAYLISTS_FOUND' | translate }}</div>
	</div>
	<!-- no results -->
</div>
